<template>
  <div :id="dropzoneId" class="dropzone"></div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onBeforeUnmount, ref, Ref } from 'vue';
import Dropzone, { DropzoneOptions, DropzoneFile } from 'dropzone';
import 'dropzone/dist/dropzone.css';

export default defineComponent({
  name: 'DropzoneComponent',
  props: {
    options: {
      type: Object as () => Partial<DropzoneOptions>,
      default: () => ({}),
    },
    id: {
      type: String as () => string | null,
      default: null,
    },
  },
  emits: ['success', 'error', 'addedfile', 'removedfile'],
  setup(props, { emit }) {
    const dropzoneId = props.id || `dropzone-${Math.random().toString(36).substr(2, 9)}`;
    const dropzoneInstance: Ref<Dropzone | null> = ref(null);

    // Dropzone.prototype.defaultOptions.dictDefaultMessage = "Drop files here to upload";
    // Dropzone.prototype.defaultOptions.dictFallbackMessage = "Your browser does not support drag'n'drop file uploads.";
    // Dropzone.prototype.defaultOptions.dictFallbackText = "Please use the fallback form below to upload your files like in the olden days.";
    // Dropzone.prototype.defaultOptions.dictFileTooBig = "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.";
    // Dropzone.prototype.defaultOptions.dictInvalidFileType = "You can't upload files of this type.";
    // Dropzone.prototype.defaultOptions.dictResponseError = "Server responded with {{statusCode}} code.";
    // Dropzone.prototype.defaultOptions.dictCancelUpload = "Cancel upload";
    // Dropzone.prototype.defaultOptions.dictCancelUploadConfirmation = "Are you sure you want to cancel this upload?";
    // Dropzone.prototype.defaultOptions.dictRemoveFile = "Remove file";
    // Dropzone.prototype.defaultOptions.dictMaxFilesExceeded = "You can not upload any more files.";

    onMounted(() => {
      // Prevent Dropzone from auto-discovering elements
      Dropzone.autoDiscover = false;

      // Default options
      const defaultOptions: Partial<DropzoneOptions> = {
        init() {
          this.on('success', (file: DropzoneFile, response: any) => {
            dropzoneInstance.value?.removeFile(file);
            emit('success', { file, response });
          });
          this.on('error', (file: DropzoneFile, errorMessage: string | Error) => {
            emit('error', { file, errorMessage });
          });
          this.on('addedfile', (file: DropzoneFile) => {
            emit('addedfile', file);
          });
          this.on('removedfile', (file: DropzoneFile) => {
            emit('removedfile', file);
          });
        },
      };

      // Merge user-defined options with defaults
      const dzOptions = { ...defaultOptions, ...props.options };

      // Initialize Dropzone
      dropzoneInstance.value = new Dropzone(`#${dropzoneId}`, dzOptions);
    });

    onBeforeUnmount(() => {
      // Destroy Dropzone instance to clean up
      if (dropzoneInstance.value) {
        dropzoneInstance.value.destroy();
      }
    });

    return {
      dropzoneId,
    };
  },
});
</script>

<style scoped>
.dropzone {
  border: 2px dashed #ccc;
  border-radius: 0.5rem;
  background: #f9f9f9;
  padding: 20px;
}
</style>